import { Box, Text } from '@chakra-ui/react';
import React from 'react';
import { Card } from '../card';
import { Tag } from '../tag';
export const GridCard = (props)=>{
    const { content , image , tag , title , orientation ='vertical' , ...cardProps } = props;
    const style = orientation === 'vertical' ? {
        card: {
            flexDirection: 'column',
            h: image ? '328px' : '156px',
            size: 's'
        },
        image: {
            borderTopRadius: '2xl'
        }
    } : {
        card: {
            flexDirection: 'row',
            h: '156px',
            size: '2xl'
        },
        image: {
            borderStartRadius: '2xl'
        }
    };
    return /*#__PURE__*/ React.createElement(Card, {
        borderRadius: "2xl",
        ...style.card,
        ...cardProps
    }, image && /*#__PURE__*/ React.createElement(Box, {
        as: "figure",
        boxSize: "156px",
        flexShrink: 0,
        overflow: "hidden",
        ...style.image
    }, image), /*#__PURE__*/ React.createElement(Box, {
        px: 1,
        py: 1.5
    }, /*#__PURE__*/ React.createElement(Tag, {
        uppercase: true,
        ...tag
    }), /*#__PURE__*/ React.createElement(Text, {
        color: "text.primary",
        mt: 1,
        textStyle: "lBold"
    }, title), /*#__PURE__*/ React.createElement(Text, {
        color: "text.secondary",
        mt: 0.5,
        noOfLines: 3,
        textStyle: "m"
    }, content)));
};

//# sourceMappingURL=grid-card.js.map